import React from 'react';
import InfoBlock from '../../../../components/InfoBlock/InfoBlock';
import CommentCard from './components/CommentCard';
import PhotosCard from './components/PhotosCard';
import DescriptionCard from './components/DescriptionCard';

const CommonInfoBlock = ({ room }) => {
  return (
    <InfoBlock title="Общая информация">
      <DescriptionCard room={room} />
      <PhotosCard room={room} />
      <CommentCard room={room} />
    </InfoBlock>
  );
};

export default CommonInfoBlock;
